import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "ChatDemo",
      component: (r) =>
        require.ensure(
          [],
          () => r(require("@/pages/chat-demo/main.vue")),
          "ChatDemo"
        ),
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js